export const stateName = 'ads';